<app-loading
  [loading] = loading
></app-loading>
<app-header></app-header>
<app-sidebar></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Clientes"
      Pagina="Cliente"
    ></app-breadcrumb>
    <app-novo-cliente
      [habilitarNovo] = habilitarNovo
      (fecharModalCalled)="fecharModalNovo()"
      (atualizarListaCalled)="buscarListaClientes()"
    >
    </app-novo-cliente>
    <app-detalhes-cliente
      [habilitarEdicao]="habilitarDetalhes"
      [clienteId]="clienteIdSelecionado"
      (fecharModalCalled)="fecharModalDetalhes()"
      (atualizarListaCalled)="buscarListaClientes()"
    ></app-detalhes-cliente>
    <div class="row">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 text-right" style="margin-bottom: 10px;">
            <a (click)="abrirModalNovo()"><button class="btn btn-primary"><i class="fa fa-plus"></i> Cadastrar</button></a>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-12">
                <div class="card card-blue" style="margin-top:10px;padding-top: 7px">
                  <div class="card-header">
                    <h3 class="card-title">Lista de clientes</h3>
                    <div class="card-tools">
                      <div class="input-group input-group-sm" style="width: 350px;">
                        <input type="text" name="table_search" (keyup)="buscarLista()" [(ngModel)]="termoBusca" class="form-control float-right" placeholder="Buscar cliente">
                        <div class="input-group-append">
                          <button *ngIf="filtro" class="btn btn-danger" (click)="limparFiltro()">
                            <i class="fa fa-eraser"></i>
                          </button>
                          <button *ngIf="!filtro" type="submit" class="btn btn-default">
                            <i class="fa fa-search text-white"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body table-responsive p-0">
                    <table class="table table-hover table-borderless table-head-fixed table-striped text-nowrap">
                      <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Telefone</th>
                        <th>Tipo Documento</th>
                        <th>Documento</th>
                        <th>Ativo</th>
                        <th style="width: 20px">*</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let item of listaFiltrada | paginate: { itemsPerPage: 10, currentPage: paginaAtual }">
                        <td>{{item.nome}}</td>
                        <td>{{(item.telefones && item.telefones.length > 0) ? (item.telefones[0].descricao | telefoneFormat) : ''}}</td>
                        <td>{{item.tipoDocumentoDescricao}}</td>
                        <td>{{item.documento | documentoFormat:item.tipoDocumentoDescricao}}</td>
                        <td>{{item.ativo ? 'Ativo' : 'Desativado'}}</td>
                        <td><a (click)="abrirModalDetalhes(item.id)" style="cursor: pointer"> <button class="btn btn-warning"><i class="fa fa-edit"></i></button></a></td>
                      </tr>
                      <tr *ngIf="listaFiltrada && listaFiltrada.length == 0">
                        <td colspan="6" class="text-center text-orange">Nenhum registro a ser mostrado</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="card-footer clearfix text-center" *ngIf="listaFiltrada && listaFiltrada.length > 0">
                    <pagination-controls class="pagination-sm"
                                         [autoHide]="false"
                                         [directionLinks]="true"
                                         previousLabel="Anterior"
                                         nextLabel="Próximo"
                                         (pageChange)="pageChange($event)">
                    </pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
